import { IFrames, IHiddenRanges } from 'src/interfaces/global';
import NGText from 'src/styles/theme/components/NGText';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addFramesStyles, addHiddenRangesStyles, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { INGLogo } from './NGLogo.type';

export const StyledLogo = styled.button<INGLogo>`
	position: relative;
	color: white;

	display: inline-block;

	background-color: transparent;
	border: none;
	padding: 0;

	cursor: pointer;

	${(p) =>
		p.betaVisible
			? css`
					margin-right: 80px;

					${mq(EMediaQuery.lg, 'margin-right: 50px;')}
			  `
			: ''}

	svg {
		color: white;
	}
`;

export const NGTextEx = styled(NGText)`
	position: absolute;
	top: 5px;
	right: -30px;

	font-size: 0.6rem;

	${mq(EMediaQuery.sm, 'font-size: 0.5rem; top: -6px; right: -22px;')}
`;

export const StyledLogoImage = styled.div<IHiddenRanges & IFrames>`
	position: relative;
	${(p) => `${addHiddenRangesStyles(p)} ${addFramesStyles(p)}`}
	height: 32px;
	width: ${(p) => (typeof p.width === 'number' ? p.width + 'px' : p.width)};

	${mq(EMediaQuery.sm, 'height: 16px;')}
`;
